export default __webpack_public_path__ + "static/emccave-09393052ae7f116e0a6e708251e631a0.gif";